/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/IntegrationSourceCompanyStatus'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/IntegrationSourceCompanyStatus'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationSourceCompanyStatusApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.IntegrationSourceCompanyStatus);
  }
}(this, function(ApiClient, IntegrationSourceCompanyStatus) {
  'use strict';

  /**
   * IntegrationSourceCompanyStatus service.
   * @module api/IntegrationSourceCompanyStatusApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new IntegrationSourceCompanyStatusApi. 
   * @alias module:api/IntegrationSourceCompanyStatusApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the integrationSourceCompanyStatusAddPut operation.
     * @callback module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/IntegrationSourceCompanyStatus} body 
     * @param {module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.integrationSourceCompanyStatusAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationSourceCompanyStatusAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling integrationSourceCompanyStatusAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/IntegrationSourceCompanyStatus/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationSourceCompanyStatusDemandDataFromIntegrationSourceGet operation.
     * @callback module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusDemandDataFromIntegrationSourceGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * demandDataFromIntegrationSource
     * @param {String} _4SAPIAppID 
     * @param {Integer} integrationSourceID 
     * @param {module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusDemandDataFromIntegrationSourceGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationSourceCompanyStatusDemandDataFromIntegrationSourceGet = function(_4SAPIAppID, integrationSourceID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationSourceCompanyStatusDemandDataFromIntegrationSourceGet";
      }

      // verify the required parameter 'integrationSourceID' is set
      if (integrationSourceID == undefined || integrationSourceID == null) {
        throw "Missing the required parameter 'integrationSourceID' when calling integrationSourceCompanyStatusDemandDataFromIntegrationSourceGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'integrationSourceID': integrationSourceID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationSourceCompanyStatus/demandDataFromIntegrationSource', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet operation.
     * @callback module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * demandSpecificDataFromIntegrationSource
     * @param {String} _4SAPIAppID 
     * @param {Integer} sourceID 
     * @param {Boolean} importAccounting 
     * @param {Boolean} importInvoicing 
     * @param {Date} startDate 
     * @param {module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet = function(_4SAPIAppID, sourceID, importAccounting, importInvoicing, startDate, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet";
      }

      // verify the required parameter 'sourceID' is set
      if (sourceID == undefined || sourceID == null) {
        throw "Missing the required parameter 'sourceID' when calling integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet";
      }

      // verify the required parameter 'importAccounting' is set
      if (importAccounting == undefined || importAccounting == null) {
        throw "Missing the required parameter 'importAccounting' when calling integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet";
      }

      // verify the required parameter 'importInvoicing' is set
      if (importInvoicing == undefined || importInvoicing == null) {
        throw "Missing the required parameter 'importInvoicing' when calling integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling integrationSourceCompanyStatusDemandSpecificDataFromIntegrationSourceGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'sourceID': sourceID,
        'importAccounting': importAccounting,
        'importInvoicing': importInvoicing,
        'startDate': startDate
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/IntegrationSourceCompanyStatus/demandSpecificDataFromIntegrationSource', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationSourceCompanyStatusLoadAllGet operation.
     * @callback module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IntegrationSourceCompanyStatus>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IntegrationSourceCompanyStatus>}
     */
    this.integrationSourceCompanyStatusLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationSourceCompanyStatusLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [IntegrationSourceCompanyStatus];

      return this.apiClient.callApi(
        '/IntegrationSourceCompanyStatus/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGet operation.
     * @callback module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGetCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * setIntegrationSourceActiveAndGetNewStatus
     * @param {String} _4SAPIAppID 
     * @param {Integer} integrationSourceCompanyStatusID 
     * @param {Object} opts Optional parameters
     * @param {String} opts.additionalInformation  (default to )
     * @param {module:api/IntegrationSourceCompanyStatusApi~integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGet = function(_4SAPIAppID, integrationSourceCompanyStatusID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGet";
      }

      // verify the required parameter 'integrationSourceCompanyStatusID' is set
      if (integrationSourceCompanyStatusID == undefined || integrationSourceCompanyStatusID == null) {
        throw "Missing the required parameter 'integrationSourceCompanyStatusID' when calling integrationSourceCompanyStatusSetIntegrationSourceActiveAndGetNewStatusGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'integrationSourceCompanyStatusID': integrationSourceCompanyStatusID,
        'additionalInformation': opts['additionalInformation']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/IntegrationSourceCompanyStatus/setIntegrationSourceActiveAndGetNewStatus', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
